import { Component, OnDestroy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import * as Reducers from 'src/app/store/reducers'
import * as UserActions from 'src/app/store/user/actions'

@Component({
	selector: 'app-system-register',
	templateUrl: './register.component.html',
	styleUrls: ['../style.component.scss'],
})
export class RegisterComponent implements OnDestroy {
	form: FormGroup
	loading = false

	private subscription = new Subscription();

	constructor(private fb: FormBuilder, private store: Store<any>) {
		this.form = fb.group({
			email: [undefined, [Validators.required, Validators.minLength(4)]],
			password: [undefined, [Validators.required]],
			name: [undefined, [Validators.required]],
		})
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.loading = state.loading
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get email() {
		return this.form.controls.email
	}
	get password() {
		return this.form.controls.password
	}
	get name() {
		return this.form.controls.name
	}

	submitForm(): void {
		this.email.markAsDirty()
		this.email.updateValueAndValidity()
		this.password.markAsDirty()
		this.password.updateValueAndValidity()
		this.name.markAsDirty()
		this.name.updateValueAndValidity()
		if (this.email.invalid || this.password.invalid || this.name.invalid) {
			return
		}
		const payload = {
			email: this.email.value,
			password: this.password.value,
			name: this.name.value,
		}
		this.store.dispatch(new UserActions.Register(payload))
	}
}
